import { render, staticRenderFns } from "./AffiliationForm.vue?vue&type=template&id=6f5da396"
import script from "./AffiliationForm.vue?vue&type=script&lang=js"
export * from "./AffiliationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports